{
  "confirmInvalidateDescription": "Altre aziende agricole non potranno più utilizzare questo codice per aggiungere questo dispositivo al proprio account",
  "createDeviceShareCodeInstructions": "Imposta le autorizzazioni per le aziende agricole che utilizzeranno questo dispositivo.",
  "createDeviceShareCodeSuccessMessage": "Il tuo codice di condivisione è stato creato con successo.",
  "currentDeviceShareCode": "Codice attuale",
  "deviceOwnership": "Proprietà del dispositivo",
  "deviceOwnershipLinkTo": "Proprietà",
  "farmsBorrowingDeviceListEmpty": "Al momento nessuna azienda agricola sta prendendo in prestito questo dispositivo.",
  "helpContent": "I dispositivi possono essere condivisi con altre farm tramite un codice di condivisione dispositivo. Puoi concedere l'accesso a utenti esterni alla tua farm e specificare permessi specifici per loro mentre utilizzano il dispositivo.",
  "invalidateButton": "Invalidare",
  "newDeviceShareCode": "Nuovo codice di condivisione del dispositivo",
  "primaryOwnerLabel": "Proprietario principale",
  "requestDeviceRemovalButton": "Rimuovi dispositivo",
  "requestDeviceRemovalDescription": "Il dispositivo verrà rimosso da questo account farm.",
  "requestDeviceRemovalInstructions": "Per continuare, digitare l'alias del dispositivo.",
  "requestDeviceRemovalNote": "Nota: questa azione non influirà sulla fatturazione",
  "requestDeviceRemovalTitle": "Richiedi la rimozione del dispositivo",
  "requestRemovalALiasMustMatchErrorMessageWithCodaDeviceAlias": "L'alias deve corrispondere esattamente a {{codaDeviceAlias}}.",
  "shareDeviceShareCodeMessagePrefixWithCodeStrAndDeviceName": "Inserisci questo codice per accedere al dispositivo FarmHQ {{deviceName}}: {{codeStr}}",
  "shareTitlePrefixWithFarmName": "[FarmHQ]: Codice di condivisione del dispositivo da {{farmName}}"
}
